import getCookie from './GetCookie';

var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export default ()=>{


    try {
        if(getCookie('INSIGNIA_USER') === 'true'){
            document.querySelector('.sf-chatbot') && document.querySelector('.sf-chatbot').classList.add('insignia');
            return true;
        }
        delete_cookie('INSIGNIA_USER');
        document.querySelector('.sf-chatbot.insignia') && document.querySelector('.sf-chatbot.insignia').classList.remove('insignia');
        return false; //make this false for insignia* 
    } catch (error) {
        console.log(error);
    }

   

}